import { InvoiceDetails } from "@/types/invoice";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type InvoiceActionState = {
  invoice: InvoiceDetails | null;
};

const initialState: InvoiceActionState = {
  invoice: null,
};

const invoiceSlice = createSlice({
  name: "invoice",
  initialState,
  reducers: {
    setInvoice: (state, action: PayloadAction<InvoiceDetails | null>) => {
      state.invoice = action.payload;
    },
    resetInvoice: (state) => {
      state.invoice = null;
    },
  },
});

export const { setInvoice, resetInvoice } = invoiceSlice.actions;

export default invoiceSlice.reducer;
